/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIUnitEconomicsBaselineSortCriteria {
    getFixupPrototypeFunction() { return AIUnitEconomicsBaselineSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<AIUnitEconomicsBaselineSortCriteria>): AIUnitEconomicsBaselineSortCriteria {
        let obj = Object.assign(new AIUnitEconomicsBaselineSortCriteria(), model);
        AIUnitEconomicsBaselineSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIUnitEconomicsBaselineSortCriteria>): AIUnitEconomicsBaselineSortCriteria {
        if (!model) return null;
        return AIUnitEconomicsBaselineSortCriteria.newInstance(<AIUnitEconomicsBaselineSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIUnitEconomicsBaselineSortCriteria) {
        if (!obj) return;

        models.AIUnitEconomicsBaselineSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIUnitEconomicsBaselineSortCriteria): boolean {
        Object.setPrototypeOf(obj, AIUnitEconomicsBaselineSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.AIUnitEconomicsBaselineSortColumn;

    ascending: boolean;

}
